<template>
  <footer class="the-footer">
    <div class="container">
      <div class="the-footer__content">
        <div class="the-footer__brand">
          <img src="@/assets/img/kaonR_logo.svg" alt="Kaon R" class="the-footer__logo" />
          <p class="the-footer__description">
            南青山の癒しと美容の専門サロン<br>
            初期費用0円で本格的なサロンをご利用いただけます
          </p>
          <div class="the-footer__social">
            <a
              href="https://twitter.com/kaonR20221001"
              target="_blank"
              rel="noopener noreferrer"
              class="the-footer__social-link"
              aria-label="Twitter"
            >
              <i class="fab fa-twitter"></i>
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=100086545601576"
              target="_blank"
              rel="noopener noreferrer"
              class="the-footer__social-link"
              aria-label="Facebook"
            >
              <i class="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://www.instagram.com/kaon_r/"
              target="_blank"
              rel="noopener noreferrer"
              class="the-footer__social-link"
              aria-label="Instagram"
            >
              <i class="fab fa-instagram"></i>
            </a>
            <a
              href="https://lin.ee/ETPLtSN"
              target="_blank"
              rel="noopener noreferrer"
              class="the-footer__social-link"
              aria-label="LINE"
            >
              <i class="fab fa-line"></i>
            </a>
          </div>
        </div>
        
        <div class="the-footer__links">
          <div class="the-footer__column">
            <h4 class="the-footer__heading">サイトマップ</h4>
            <ul class="the-footer__list">
              <li><router-link to="/" class="the-footer__link">TOP</router-link></li>
              <li><router-link to="/about" class="the-footer__link">ABOUT</router-link></li>
              <li><router-link to="/reserve" class="the-footer__link">RESERVE</router-link></li>
              <li><router-link to="/contact" class="the-footer__link">CONTACT</router-link></li>
            </ul>
          </div>
          
          <div class="the-footer__column">
            <h4 class="the-footer__heading">サービス</h4>
            <ul class="the-footer__list">
              <li><a href="#" @click.prevent="openModal('equipment')" class="the-footer__link">設備紹介</a></li>
              <li><a href="#" @click.prevent="openModal('price')" class="the-footer__link">料金プラン</a></li>
              <li><a href="#" @click.prevent="openModal('flow')" class="the-footer__link">ご利用の流れ</a></li>
            </ul>
          </div>
          
          <div class="the-footer__column">
            <h4 class="the-footer__heading">お問い合わせ</h4>
            <ul class="the-footer__list the-footer__list--contact">
              <li>
                <i class="fas fa-map-marker-alt"></i>
                <span>東京都港区南青山2-2-15<br>ウィン青山</span>
              </li>
              <li>
                <i class="fas fa-train"></i>
                <span>青山一丁目駅徒歩1分</span>
              </li>
              <li>
                <base-button
                  variant="outline"
                  size="sm"
                  block
                  to="/reserve"
                >
                  見学・レンタル予約はこちら
                </base-button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      <div class="the-footer__bottom">
        <div class="the-footer__copyright">
          &copy; 2024 Kaon R. All rights reserved.
        </div>
        <div class="the-footer__legal">
          <router-link to="/tradelaw" class="the-footer__legal-link">
            特定商取引法に基づく表記
          </router-link>
        </div>
      </div>
    </div>
    
    <!-- Modals -->
    <base-modal
      v-model="modals.equipment"
      title="設備紹介"
      size="large"
    >
      <equipment-modal-content />
    </base-modal>
    
    <base-modal
      v-model="modals.price"
      title="料金プラン"
    >
      <price-modal-content />
    </base-modal>
    
    <base-modal
      v-model="modals.flow"
      title="ご利用の流れ"
    >
      <flow-modal-content />
    </base-modal>
  </footer>
</template>

<script>
import BaseButton from '@/components/common/BaseButton.vue';
import BaseModal from '@/components/common/BaseModal.vue';
import EquipmentModalContent from '@/components/sections/EquipmentModalContent.vue';
import PriceModalContent from '@/components/sections/PriceModalContent.vue';
import FlowModalContent from '@/components/sections/FlowModalContent.vue';

export default {
  name: 'TheFooter',
  components: {
    BaseButton,
    BaseModal,
    EquipmentModalContent,
    PriceModalContent,
    FlowModalContent
  },
  data() {
    return {
      modals: {
        equipment: false,
        price: false,
        flow: false
      }
    };
  },
  methods: {
    openModal(modalName) {
      this.modals[modalName] = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.the-footer {
  background-color: $gray-900;
  color: $gray-300;
  padding-top: $spacing-4xl;
  
  &__content {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: $spacing-3xl;
    margin-bottom: $spacing-3xl;
    
    @include media-breakpoint-down(md) {
      grid-template-columns: 1fr;
      gap: $spacing-2xl;
    }
  }
  
  &__brand {
    max-width: 300px;
  }
  
  &__logo {
    height: 40px;
    margin-bottom: $spacing-lg;
    filter: brightness(0) invert(1);
  }
  
  &__description {
    font-size: $font-size-sm;
    line-height: 1.7;
    margin-bottom: $spacing-lg;
    color: $gray-400;
  }
  
  &__social {
    display: flex;
    gap: $spacing-md;
    
    &-link {
      @include flex-center;
      width: 40px;
      height: 40px;
      border-radius: $radius-full;
      background-color: rgba($white, 0.1);
      color: $white;
      transition: all $transition-fast;
      
      &:hover {
        background-color: $primary-color;
        transform: translateY(-2px);
      }
      
      i {
        font-size: $font-size-lg;
      }
    }
  }
  
  &__links {
    display: grid;
    grid-template-columns: 1fr 1fr 1.5fr;
    gap: $spacing-2xl;
    
    @include media-breakpoint-down(md) {
      grid-template-columns: 1fr;
      gap: $spacing-xl;
    }
  }
  
  &__column {
    min-width: 0;
  }
  
  &__heading {
    font-size: $font-size-md;
    font-weight: 600;
    color: $white;
    margin-bottom: $spacing-md;
  }
  
  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      margin-bottom: $spacing-sm;
    }
    
    &--contact {
      li {
        display: flex;
        align-items: flex-start;
        gap: $spacing-sm;
        margin-bottom: $spacing-md;

        i {
          color: $primary-light;
          margin-top: 2px;
          flex-shrink: 0;
        }

        span {
          font-size: $font-size-sm;
          line-height: 1.6;
        }

        &:last-child {
          display: block;
        }
      }
    }
  }
  
  &__link {
    color: $gray-400;
    text-decoration: none;
    font-size: $font-size-sm;
    transition: color $transition-fast;
    
    &:hover {
      color: $primary-light;
      text-decoration: none;
    }
  }
  
  &__bottom {
    @include flex-between;
    padding: $spacing-lg 0;
    border-top: 1px solid rgba($white, 0.1);
    
    @include media-breakpoint-down(sm) {
      flex-direction: column;
      gap: $spacing-md;
      text-align: center;
    }
  }
  
  &__copyright {
    font-size: $font-size-sm;
    color: $gray-500;
  }
  
  &__legal {
    &-link {
      color: $gray-500;
      font-size: $font-size-sm;
      text-decoration: none;
      transition: color $transition-fast;
      
      &:hover {
        color: $gray-300;
        text-decoration: underline;
      }
    }
  }
}</style>